<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">Agents</h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <form-navigation-tabs
              :tabs="tabs"
              v-on:selected="setActive"
              :active="currentView"
            ></form-navigation-tabs>

            <div v-if="currentView == 'details'">
              <inputbox
                v-model="form.name"
                name="name"
                label="Name"
                :required="true"
                :error-message="form.errors.get('name')"
                :show-error="form.errors.has('name')"
              ></inputbox>

              <inputbox
                v-model="form.telephone"
                name="telephone"
                label="Telephone"
              ></inputbox>

              <inputbox
                v-model="form.email"
                :error-message="form.errors.get('email')"
                :required="true"
                :show-error="form.errors.has('email')"
                name="email"
                type="email"
                label="Email Address"
              ></inputbox>

              <address-lookup
                :address="address"
                v-on:address="setAddress"
                :enable-lookup="!form.errors.any()"
              ></address-lookup>

              <toggleswitch
                :labels="true"
                v-model="form.active"
                name="active"
                label="Active"
              ></toggleswitch>
            </div>
            <modules v-if="currentView == 'modules'"></modules>
            <users v-if="currentView == 'users'"></users>
            <credit-hire-organisations
              v-if="currentView == 'credit_hire_organisations'"
            ></credit-hire-organisations>
          </div>
          <div class="card-footer text-right" v-if="currentView == 'details'">
            <button
              class="btn btn-primary btn-raised"
              name="save"
              v-on:click.prevent="submit"
            >
              <i class="icon icon-save"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Users from './Form/Users.vue';
import Modules from './Form/Modules.vue';
import CreditHireOrganisations from './Form/CreditHireOrganisations.vue';
import PageHeader from './../Modules/Shared/PageHeader.vue';

export default {
  props: {
    agent: {
      type: String,
      required: false
    }
  },

  components: {
    Modules,
    Users,
    CreditHireOrganisations,
    PageHeader
  },

  data() {
    return {
      currentView: 'details',
      form: new window.Form({
        name: null,
        telephone: null,
        email: null,
        active: true,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        enabledModules: []
      }),
      tabs: [
        {
          name: 'details',
          label: 'Details',
          disabled: false
        }
      ],
      modules: [],
      draggingKey: null
    };
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    },

    exists() {
      if (this.agent) {
        return true;
      }

      return false;
    }
  },

  mounted() {
    if (this.agent) {
      this.findAgent();
      this.addTabs(false);
    } else {
      this.addTabs(true);
    }
  },

  methods: {
    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    addTabs(disabled) {
      this.tabs.push(
        {
          name: 'modules',
          label: 'Modules',
          disabled: disabled
        },
        {
          name: 'users',
          label: 'Users',
          disabled: disabled
        },
        {
          name: 'credit_hire_organisations',
          label: 'Credit Hire Organisations',
          disabled: disabled
        }
      );
    },

    setActive(view) {
      this.currentView = view;
    },

    submit() {
      let method = 'post';
      let url = '/agents';

      if (this.agent) {
        url = `/agents/${this.agent}`;
        method = 'put';
      }

      this.form[method](url)
        .then(response => {
          this.route(`/agents/${response.identifier}`);
          window.toastify.success(
            'Saved!',
            'The agent was saved successfully!'
          );
        })
        .catch(error => {
          window.swal(
            'Oops...',
            'Sorry, there was a problem saving the agent.',
            'error'
          );
        });
    },

    findAgent() {
      window.Ajax.get(`/agents/${this.agent}`)
        .then(response => {
          this.form.name = response.data.name;
          this.form.email = response.data.email;
          this.form.telephone = response.data.telephone;
          this.form.active = response.data.active;
          this.form.address_line_one = response.data.address_line_one;
          this.form.address_line_two = response.data.address_line_two;
          this.form.city = response.data.city;
          this.form.postcode = response.data.postcode;

          this.activateTabs();
        })
        .catch(err => {});
    },

    activateTabs() {
      let length = this.tabs.length;

      for (let i = 0; i < length; i++) {
        this.tabs[i].disabled = false;
      }
    }
  },

  watch: {
    agent(value) {
      if (value) {
        this.findAgent();
      }
    }
  }
};
</script>
